import {
  IconAnalytics,
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconPenSquare,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/retailOffice/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/retailOffice/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/retailOffice/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/retailOffice/video/sub/rtlsVideo3.mp4';

import image1 from '@src/assets/images/solution/retailOffice/img/1.avif';
import image2 from '@src/assets/images/solution/retailOffice/img/2.avif';
import image3 from '@src/assets/images/solution/retailOffice/img/3.avif';
import image4 from '@src/assets/images/solution/retailOffice/img/4.avif';
import image5 from '@src/assets/images/solution/retailOffice/img/5.avif';
import { recommendationServer, retailOffice1, retailOffice2, retailOffice3 } from '@assets/images/solution/recommendation';
import recommendation from '../common/recommendation';

export default {
  type: '오피스 솔루션',
  banner: {
    title: '사무실 자산을 실시간으로 추적해 반출을 방지하고 분실을 막으세요',
    desc: '자산 태그로 사무실 내 자산의 현재 위치를 추적하고 외부 반출 시 자동 알림을 전송합니다',
  },

  recommend: {
    title: '자산의 위치를 추적하고 외부 반출 시 경고를 전송합니다',
    desc: '사무실 자산에 부착된 위치 태그와 출입구 수신기를 연동해 위치 데이터를 수집하고 반출 상황을 실시간 감지합니다',
    labels: {
      desktop: [
        {
          img: retailOffice1,
          data: recommendation.twintarckerBLE,
        },
        {
          img: retailOffice2,
          data: recommendation.stickerTag,
        },
        {
          img: retailOffice3,
          data: recommendation.slimTag,
        },
        {
          img: recommendationServer,
          data: recommendation.server,
        },
      ],
      mobile: [
        {
          data: recommendation.twintarckerBLE,
        },
        {
          data: recommendation.stickerTag,
        },
        {
          data: recommendation.slimTag,
        },
        {
          data: recommendation.server,
        },
      ],
    },
  },

  video: {
    title: '자산 위치 데이터를 기반으로 사무실 운영 효율을 극대화하세요.',
    desc: '사무실 내 모든 자산의 위치와 상태를 실시간으로 모니터링하여 자산 분실을 방지하고 관리 효율성을 높이며, 관리자의 업무 편의성과 신속한 대응을 지원합니다.',
    play: video,
  },

  func: [
    {
      theme: '사무실 자산의 위치를 실시간으로 추적하여 효율적인 운영을 지원하세요.',
      title: '노트북 및 고가 자산 위치 모니터링',
      desc: '사무실 내 모든 노트북 자산의 실시간 위치를 정확히 파악하여 자산 관리 업무의 정확도와 효율성을 크게 높이고 자산 분실을 예방합니다.',
      sub1: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub2: '높은 정확도 제공',
      icon2: IconRulerGray,
      image: image1,
    },
    {
      title: '전용 자산 관리 태그 제공',
      desc: '노트북에 쉽게 부착 가능한 전용 위치추적 태그로 손쉽게 자산 위치를 확인할 수 있어 관리 효율성이 대폭 개선됩니다.',
      sub1: '실시간 현황 파악',
      icon1: IconClockGray,
      sub2: '빠른 데이터 연동',
      icon2: IconShareGray,
      image: image2,
    },
    {
      title: '자산 반출 자동 승인 프로세스',
      desc: '자산 반출 신청 시 관리자에게 자동으로 알림이 전송되며, 관리자가 간편하게 승인하여 기존의 복잡한 자산 반출 절차를 획기적으로 간소화할 수 있습니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image3,
    },
    {
      title: '무단 반출 실시간 경고 알림',
      desc: '노트북이 승인 없이 무단으로 반출될 경우 즉시 관리자에게 실시간 알림을 전송하여 신속한 대응과 자산 보호를 지원합니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      video: subVideo1,
    },
    {
      theme: '스마트한 운영 관리로 사무실 환경을 최적화하세요.',
      title: '방문객 위치기반 출입 통제 및 관리',
      desc: '방문객에게 위치추적이 가능한 방문증을 제공하여 지정된 구역 외 접근을 즉시 탐지하고 실시간으로 관리할 수 있습니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      title: '위치 기반 스마트 환경 제어',
      desc: '사무실 내 직원과 방문객의 위치를 기반으로 회의실 조명과 에어컨 등을 자동으로 제어하여 에너지 효율과 편의성을 향상합니다.<br/><br/> • 방문객과 직원의 위치를 기반으로 재실 여부 판단<br/><br/> • 입실 시 자동으로 조명 및 에어컨 가동<br/><br/> • 퇴실 시 조명 및 에어컨 자동으로 종료',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      title: '자산 위치 빠른 검색 기능',
      desc: '자산 위치 검색 기능으로 원하는 자산의 위치를 신속하게 찾을 수 있어 업무 효율성과 관리 편의성을 크게 높입니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      video: subVideo2,
    },
    {
      title: '내부 및 외부 자산 재고 실시간 확인',
      desc: '회사 내부와 외부에 있는 노트북 자산의 재고 상태를 실시간으로 확인하여 자산의 효율적이고 정확한 관리가 가능합니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      video: subVideo3,
    },
  ],

  subfunc: {
    title: '기능 요약',
    desc: '효율적인 재고 관리, 시간 및 비용 절감, 투명성 및 추적성 등 다양한 장점이 있습니다.<br/>최적의 근무 환경을 조성하고 최고의 효율을 만들어 낼 수 있도록, 오브로는 다음과 같은 기능들을 추가로 제공합니다.',

    data: [
      {
        icon: IconRoute, // 자산 위치 추적 → 이동 경로 기반
        title: '노트북 실시간 추적',
        desc: '노트북, 태블릿 등 주요 자산의 위치를 실시간으로 파악해 분실을 방지합니다.',
      },
      {
        icon: IconSearch, // 자산 전용 태그 → 태그/탐색 의미
        title: '자산 전용 태그 제공',
        desc: '소형 경량 태그로 장비에 쉽게 부착할 수 있어 빠르게 위치 추적이 가능합니다.',
      },
      {
        icon: IconWarning, // 반출 승인 → 승인/통제/경고 의미
        title: '자동 반출 승인',
        desc: '반출 요청이 발생하면 실시간으로 알림을 전송하고 승인 이력을 자동 저장합니다.',
      },
      {
        icon: IconWarning, // 무단 반출 → 경고 알림
        title: '무단 반출 감지',
        desc: '자산이 승인 없이 이동하면 시스템이 경고를 전송해 보안을 강화합니다.',
      },
      {
        icon: IconLayers, // 출입 통제 → 공간 제어 의미
        title: '방문객 출입 통제',
        desc: '방문객의 스마트 출입증으로 구역 이탈을 자동 감지하고 즉시 알림을 전송합니다.',
      },
      {
        icon: IconAnalytics, // 환경 제어 → 위치 기반 제어, 효율 의미
        title: '스마트 환경 제어',
        desc: '위치 기반으로 조명과 냉난방을 자동 제어해 에너지 효율을 극대화합니다.',
      },
      {
        icon: IconSearch, // 자산 위치 검색 → 탐색 의미
        title: '자산 위치 검색',
        desc: '대시보드에서 자산명 또는 번호로 위치를 검색해 빠른 대응이 가능합니다.',
      },
      {
        icon: IconLayers, // 통합 관리 → 전체 자산 관리 → Layers 재사용
        title: '통합 자산 관리',
        desc: '내부와 외부 자산을 하나의 시스템으로 실시간 통합 관리할 수 있습니다.',
      },
    ],
  },

  system: {
    title: '시스템 구성',
    img: rtlsSystem,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  contents: [
    {
      data: 'logisticsAsset',
    },
    {
      data: 'manufacturingSteel',
    },
    {
      data: 'blogOffice',
    },
    {
      data: 'blogRTLS',
    },
  ],
};
